import React, { useRef, useEffect } from 'react';
import { OptionTypeBase } from 'react-select';
import Select, { Props as CreatableProps } from 'react-select/async-creatable';
import { useField } from '@unform/core';
import api from './../../api'

function SelectCreate({ name, titulo, col, router, labelValue = '', ...props }) {
    const selectRef = useRef(null);
    const { fieldName, defaultValue, registerField, error } = useField(name);

    useEffect(() => {
        registerField({
            name: fieldName,
            ref: selectRef.current,
            path: 'select.state.value',
            getValue: (ref) => {
                if (props.isMulti) {
                    if (!ref.select.state.value) {
                        return [];
                    }

                    return ref.select.state.value.map(
                        (option) => option.value,
                    );
                } else {
                    if (!ref.select.state.value) {
                        return '';
                    }

                    return ref.select.state.value.value;
                }
            },
            setValue: (ref, value) => {
                ref.select.select.select.setValue(value);
            }
        });
    }, [fieldName, registerField, props.isMulti]);

    async function onSearchData(seachText) {

        if (router) {

            const resp = await api.post(router, {
                text: seachText
            })

            if (resp.status === 200) {
                return resp.data
            }
            else {
                return []
            }
        }
    }

    return (
        <div className={`cInputD selectD group-select-${name} ${col}`} classID={labelValue}>
            <label htmlFor={name}>{titulo}</label>
            <Select
                cacheOptions
                defaultValue={defaultValue}
                ref={selectRef}
                classNamePrefix="react-select"
                placeholder='Digite para buscar ou criar'
                noOptionsMessage={() => 'Sem dados'}
                loadOptions={onSearchData}
                defaultOptions
                isClearable
                formatCreateLabel={text => `Criar ${text}`}
                theme={theme => ({
                    ...theme,
                    colors: {
                        ...theme.colors,
                        primary25: '#179c55',
                        primary: '#179c55',
                        primary50: 'rgba(23, 156, 85, 0.2)',
                    },
                })}
                {...props}
            />
            {error && <span className="error-validacao">{error}</span>}
        </div>
    );
};

export default SelectCreate;